import React from "react";
import PropTypes from "prop-types";

import ModalDialog from "components/ModalDialog";
import Button from "components/Button";

import "./AlertModal.css";

export default class AlertModal extends React.Component {

  static propTypes = {
    isOpen: PropTypes.bool,
    alertTitle: PropTypes.string,
    alertText: PropTypes.string.isRequired
  }

  static defaultProps = {
    isOpen: true
  }

  onClose = () => {
    this.props.onClose(true);
  }

  render() {
    const { isOpen, alertTitle, alertText} = this.props;
    return (
      <ModalDialog isOpen={isOpen}>
        <div>
          <div className="alert-modal__title">{alertTitle === undefined ? "Alert" : alertTitle}</div>
          <div className="alert-modal__message">{alertText}</div>
          <div className="alert-modal__button-container">
            <Button className="alert-modal__ok-button" onClick={this.onClose}>OK</Button>
          </div>
        </div>
      </ModalDialog>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/app/alert/AlertModal.js